export const tr = {
    'needs-price': 'Fiyat boş bırakılamaz',
    'price-error-text': 'Beklenmeyen bir hata oluştu. Daha sonra tekrar deneyin.',
    'price-greater-then-max': 'Fiyat, izin verilen maksimum değerin üzerinde',
    'price-greater-then-max-with-value': 'Price cannot be more than {value}',
    'price-greater-then-min': 'Price cannot be less than or equal to {value}',
    'price-validate-error': 'Doğrulama hatası oluştu. Daha sonra tekrar deneyin',
    'priceOld-greater-then-max': 'Eski fiyat, izin verilen maksimum değerin üzerinde',
    'priceOld-greater-then-max-with-value': 'Old price cannot be more than {value}',
    'priceOld-greater-then-min': 'Old price cannot be less than or equal to {value}',
    'priceOld-greater-then-price': 'Eski fiyat, yenisinin üzerinde olmalıdır'
};
